// src/utils/tien.js
//
// Định dạng tiền, dùng chung cho Báo chi tiêu và mọi chỗ sau này.
//
// Viết ra một file riêng thay vì để trong trang, vì đây là loại hàm mà
// mỗi nơi tự viết một kiểu thì con số hiện ra mỗi chỗ một khác — và
// người đọc sẽ tưởng là số liệu sai chứ không nghĩ là do định dạng.

/** 9600000 -> "9.600.000 đ" */
export const veTien = (n) => {
  const so = Number(n);
  if (!Number.isFinite(so)) return "";
  return so.toLocaleString("vi-VN") + " đ";
};

/** 800000 -> "800.000" (không kèm chữ đ, để ghép vào câu) */
export const veSo = (n) => {
  const so = Number(n);
  if (!Number.isFinite(so)) return "";
  return so.toLocaleString("vi-VN");
};

/**
 * Người ta gõ số tiền theo thói quen: "1.400.000", "1 400 000", "1400000".
 * Bắt gõ số trơn là chống lại thói quen đó mà chẳng được gì.
 * Trả về chuỗi CHỈ GỒM CHỮ SỐ để gửi lên máy chủ (máy chủ cũng tự lọc lại).
 */
export const docSoTien = (v) => String(v == null ? "" : v).replace(/[^0-9]/g, "");

/**
 * "2026-09" -> "09/2026". Nhận CHUỖI, không nhận đối tượng Date.
 *
 * ⚠️ Cố ý không dùng `new Date(...)` ở đây. Cột ngày của PostgreSQL đi qua
 * thư viện `pg` sẽ thành một khoảnh khắc kèm múi giờ, và định dạng lại nó
 * bằng giờ UTC sẽ LÙI MẤT MỘT NGÀY — với ngày mùng 1 thì lùi hẳn sang
 * tháng trước, tức là bản tin "tháng 9" hiện thành "tháng 8".
 * Máy chủ đã trả sẵn chuỗi rồi; đừng đổi lại làm gì.
 * (Xem docs/bai-hoc/2026-09-07-03_ngay-thang-va-mui-gio.md)
 */
export const veThang = (ma) => {
  if (typeof ma !== "string" || !/^\d{4}-\d{2}$/.test(ma)) return ma || "";
  return ma.slice(5) + "/" + ma.slice(0, 4);
};

/** "2026-09" -> "Tháng 9/2026" (bỏ số 0 ở đầu cho dễ đọc) */
export const veTenThang = (ma) => {
  if (typeof ma !== "string" || !/^\d{4}-\d{2}$/.test(ma)) return ma || "";
  return "Tháng " + Number(ma.slice(5)) + "/" + ma.slice(0, 4);
};
